import { buttonShuffle } from "../helpers-board.js";

/*
 Change all button text to webdings
*/
function changeFonts({ buttons, board, initialPositions, registerCleanup }) {

  return new Promise((resolve) => {
    board.classList.add('webdings');
    buttonShuffle({ board, buttons, initialPositions });

    function cleanup() {
      board.classList.remove('webdings');
      board.classList = "";
      board.classList.add("board");
      board.classList.add("composite-transform");
      buttonShuffle({ board, buttons, initialPositions });
    }

    registerCleanup(cleanup);

    resolve();
  })
}

export default changeFonts;
